import React from 'react';

const ThemeCurtain = () => {

    setTimeout(() => {
        const curtain = document.getElementsByClassName('theme-curtain');
        curtain.length && curtain[0].classList.remove('active');
    }, 2500);

    return (
        <div className="theme-curtain active"></div>
    )

};

export default ThemeCurtain;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/ThemeCurtain.js